import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';

import { NS } from '@/constants';
import { useAppDispatch, useAppSelector } from '@/redux';
import { isObjectEmpty } from '@/utils/comparisonUtils';

import { toggleTopChronoModal } from '@/redux/slices/gui.slice';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import Icon from '@/components/common/iconedLinks/Icon';

import styles from './TopChrono.module.scss';
import { URLS } from '@/constants/urls';

type TopChronoProps = {
  shippingId: string;
  isExproCheckout: boolean;
}

export const TopChrono = ({ shippingId, isExproCheckout }: TopChronoProps): React.JSX.Element => {
  const { t } = useTranslation(NS.CHECKOUT);
  const dispatch = useAppDispatch();
  const locale = useAppSelector(({ root }) => root.storeConf.locale);

  const topChronoData = useAppSelector(({ cart }) => cart.topChronoData);
  const topChronoDataExpro = useAppSelector(({ expro }) => expro.topChronoDataExpro);
  const bookingSlots = useAppSelector(({ cart }) => cart.content.shippingMode?.bookingSlot);

  const [bookingSlot, setBookingSlot] = useState(isExproCheckout ? topChronoDataExpro : topChronoData);

  useEffect(() => {
    if (!isExproCheckout) {
      setBookingSlot(topChronoData);
    }

    if (isObjectEmpty(topChronoData) && !isObjectEmpty(bookingSlots)) {
      const date = new Date(bookingSlots.start);
      const formattedDate = new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);

      const formattedStartTime = new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit'
      }).format(new Date(bookingSlots?.start));

      const formattedEndTime = new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit'
      }).format(new Date(bookingSlots?.end));

      const formatedForFrontBookingSlot = {
        day: formattedDate,
        slot: {
          start: formattedStartTime,
          end: formattedEndTime
        }
      };
      setBookingSlot(formatedForFrontBookingSlot);
    }
  }, [topChronoData]);

  useEffect(() => {
    if (isExproCheckout) {
      setBookingSlot(topChronoDataExpro);
    }
  }, [topChronoDataExpro]);

  return (
    <div className={styles.container}>
      {!isObjectEmpty(bookingSlot) && (
        <div className={styles.text}>
          <Icon src={URLS.CHECKBOX_CONFIRM_CIRCLE_GREEN} alt="confirmed" />
          <span>{t('shipMode.topChrono.delivery')}</span>
          <span className={styles.day}>
            {bookingSlot.day.replaceAll('-', '/')} {bookingSlot.slot?.start} - {bookingSlot.slot?.end}
          </span>
        </div>
      )}
      <CallToActionContainer
        onClick={() => dispatch(toggleTopChronoModal({ opened: true, shippingId }))}
      >
        {!isObjectEmpty(bookingSlot) ?
          t('shipMode.topChrono.changeSlot') : t('shipMode.topChrono.pickDateAndSlot')
        }
      </CallToActionContainer>
    </div>
  );
};

export default TopChrono;
